enum Action {
  UNASSIGN_EMPLOYMENT = 'unassignEmployment',
  ASSIGN_EMPLOYMENT = 'assignEmployment',
}

export default Action;
